export class ItemTipo {
  id: number;
  codigo: string;
  descricao: string;

  constructor(itemTipo?: ItemTipo | number) {
    if (itemTipo !== undefined && itemTipo !== null) {
      if (typeof itemTipo === 'number') {
        this.id = itemTipo;
      } else {
        this.id = itemTipo.id;
        this.codigo = itemTipo.codigo;
        this.descricao = itemTipo.descricao;
      }
    }
  }
}
